export enum ConsignmentState {
  Activo = 0,
  Nulo = 1,
  Archivado = 2,
  Liquidables = 10,
}

export enum ReservationState {
  Activo = 0,
  Completado = 1,
  Archivado = 2,
  Nulo = 3,
}

export enum SalenoteState {
  Pendiente = 0,
  Completado = 1,
  Nulo = 2,
}

export enum VehicleState {
  Publicados = 0,
  Pendientes = 1,
  Reservados = 2,
  Vendidos = 3,
  Archivados = 4,
  Cotizables = 10,
  Consignables = 11,
  Reservables = 12,
  ParteDePago = 13,
  NotasVendibles = 14,
  Creditables = 15,
  Comprables = 16,
  Negociables = 17,
}
export enum DealState {
  EnCurso = 0,
  Completados = 1,
  Cancelados = 2,
}
export enum CreditState {
  Enviados = 0,
  Aprobados = 1,
  Tomados = 2,
  Rechazados = 3,
  NoTomados = 4,
}
export enum MessageState {
  Consultas = 0,
  Otros = 1,
  Procesados = 2,
  Descartados = 3,
}
export enum DocStateSpecial {
  Nulo,
  Archivado,
  Expirado,
  Activo,
  Aprobado,
  Desactivado,
  Descartado,
}
export enum UserState {
  Activo,
  Inactivo,
}
export enum BranchState {
  Activo,
  Inactivo,
}
